import { useMemo } from 'react'
import { useLocalStorage } from '@arcivr/sp-ui-lib'
import { FiltersState } from 'pages/TotalsByEventPage'

export const FILTERS_STORAGE_KEY = 'analytics_filters'

export const usePersistentAnalyticsFilters = (defaultFilters: FiltersState): readonly [FiltersState, (value: FiltersState) => void] => {
  const [storedFilters, setStoredFilters] = useLocalStorage<FiltersState>(FILTERS_STORAGE_KEY, defaultFilters)

  const hydratedFilters = useMemo(() => {
    return {
      ...storedFilters,
      range: {
        startDate: new Date(storedFilters.range.startDate),
        endDate: new Date(storedFilters.range.endDate)
      }
    }
  }, [storedFilters])

  return [hydratedFilters, setStoredFilters] as const
}
